function cov_dlrv86qao() {
  var path = "/app/src/constants/learn-more.ts";
  var hash = "d74f352b66396df6ce8b93aadc404d7cf3e57442";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/constants/learn-more.ts",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 57
        },
        end: {
          line: 3,
          column: 1
        }
      },
      "1": {
        start: {
          line: 5,
          column: 33
        },
        end: {
          line: 11,
          column: 10
        }
      },
      "2": {
        start: {
          line: 13,
          column: 29
        },
        end: {
          line: 13,
          column: 32
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d74f352b66396df6ce8b93aadc404d7cf3e57442"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_dlrv86qao = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_dlrv86qao();
export var INSTALLMENTS_COUNT_LIST_FOR_DEFAULT_PROMO = (cov_dlrv86qao().s[0]++, [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
export var INSTALLMENT_PLANS = (cov_dlrv86qao().s[1]++, {
  three: 3,
  four: 4,
  six: 6,
  eight: 8,
  twelve: 12
});
export var INITIAL_PRICE = (cov_dlrv86qao().s[2]++, 100);